import React from 'react';
import { wrapFunctionalComponent } from 'utils/framework';

import Modal from 'components/Modal/Modal';
import AccountGreeting from 'components/Header/AccountGreeting';
import AccountMenu from 'components/Header/AccountMenu';

function AccountModal({ onDismiss, ...props }) {
    return (
        <Modal
            customStyle={styles.modal}
            isFlyout={true}
            isOpen={true}
            onDismiss={onDismiss}
        >
            <Modal.Header
                isLeftAligned={true}
                minHeight='auto'
                paddingBottom={2}
                paddingTop={7}
                paddingLeft={[4, 4]}
                paddingRight={[4, 4]}
            >
                <AccountGreeting onDismiss={onDismiss} />
            </Modal.Header>
            <Modal.Body
                paddingTop={null}
                paddingX={null}
            >
                <AccountMenu
                    onDismiss={onDismiss}
                    isBottomNav={props.isBottomNav}
                />
            </Modal.Body>
        </Modal>
    );
}

const styles = {
    modal: {
        close: {
            top: 0
        }
    }
};

export default wrapFunctionalComponent(AccountModal, 'AccountModal');
